import Vue from 'vue'
import Vuex from 'vuex'


import companyModule from './modules/company'
import proceduresModule from './modules/procedures'
import eventsModule from './modules/events'
import reportsModule from './modules/reports'
import resourcesModule from './modules/resources'
import eventResourcesModule from './modules/eventresources'
import companyNotificationsModule from './modules/companynotifications'
import dashboardModule from './modules/dashboard'
import lookupsModule from './modules/lookups'
import routineTasksModule from './modules/routinetasks'
import notificationTemplatesModule from './modules/notificationtemplates'
import adminCompaniesModule from './modules/adminCompanies'
import importExportModule from './modules/importExport'
import featureFlagsModule from './modules/featureflags'
import chatbotModule from './modules/chatbot'

Vue.use(Vuex)

export default new Vuex.Store(
  {
    modules: {
      company: companyModule,
      procedures: proceduresModule,
      events: eventsModule,
      reports: reportsModule,
      resources: resourcesModule,
      eventResources: eventResourcesModule,
      companyNotifications: companyNotificationsModule,
      dashboard: dashboardModule,
      lookups: lookupsModule,
      routineTasks: routineTasksModule,
      notificationTemplates: notificationTemplatesModule,
      adminCompanies: adminCompaniesModule,
      importExport: importExportModule,
      featureFlags: featureFlagsModule,
      chatbot: chatbotModule
    },
    state: {
      spr2Profile: null,
      userCompanies: [],
      userCurrentCompany: null,
      loggedInUserPermissions: []
    },
    mutations: {
      setSpr2Profile (state, profile) {
        console.log('setting Spr2Profile: ' + JSON.stringify(profile, null, 2))
        state.spr2Profile = profile
      },
      setUserCompanies (state, companies) {
        // console.log('setting user companies: ' + JSON.stringify(companies, null, 2))
        state.userCompanies = companies
      },
      setLoggedInUserPermissions (state, permissions) {
        state.loggedInUserPermissions = permissions
      },
      setUserCurrentCompanyById (state, selectedCompanyId) {
        console.log('setting current company by id: ' + JSON.stringify(selectedCompanyId, null, 2))
        var selectedCompany = state.userCompanies.find(p => p.companyId === selectedCompanyId)

        // Clear company-specific cached data so it is reloaded for the new company
        if (!state.userCurrentCompany || state.userCurrentCompany.companyId !== selectedCompanyId) {
          state.company.properties = null
          state.company.vendors = null
          state.company.positionTypes = null
          state.company.activePositionTypes = null
          state.company.vendorTypes = null
          state.company.activeVendorTypes = null
          state.company.company = null
        }

        state.userCurrentCompany = selectedCompany
        localStorage.setItem('currentCompanyId', selectedCompany.companyId)
      },
      setUserCurrentCompany (state, selectedCompany) {
        console.log('setting current company: ' + JSON.stringify(selectedCompany, null, 2))

        // Clear company-specific cached data so it is reloaded for the new company
        const newId = selectedCompany ? selectedCompany.companyId : null
        const oldId = state.userCurrentCompany ? state.userCurrentCompany.companyId : null
        if (newId !== oldId) {
          state.company.properties = null
          state.company.vendors = null
          state.company.positionTypes = null
          state.company.activePositionTypes = null
          state.company.vendorTypes = null
          state.company.activeVendorTypes = null
          state.company.company = null
        }

        state.userCurrentCompany = selectedCompany
        if(selectedCompany != null) {
          localStorage.setItem('currentCompanyId', selectedCompany.companyId)
        }
      },
      updateCompanyName (state, { companyId, companyName }) {
        // Patch the matching entry in userCompanies (triggers reactivity via splice)
        const idx = state.userCompanies.findIndex(c => c.companyId === companyId)
        if (idx !== -1) {
          Vue.set(state.userCompanies, idx, { ...state.userCompanies[idx], companyName })
        }
        // Patch userCurrentCompany if it is the same company
        if (state.userCurrentCompany && state.userCurrentCompany.companyId === companyId) {
          state.userCurrentCompany = { ...state.userCurrentCompany, companyName }
        }
      }
    },
    actions: {

    }
  }
)



// WEBPACK FOOTER //
// ./src/store/index.js